/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-2/5 w-full">
        <vx-card class="mb-base">
          <h3 class="font-bold mb-4">NMAP Scan Output</h3>
          <div class="p-4 text-success" style="backdrop-filter: blur(1000px); background-color: rgb(0 0 0 / 44%)">
            <span class="font-bold">Starting Nmap 7.91 ( https://nmap.org ) at 2020-12-26 02:17 Eastern Standard Time</span><br />
            NSE: Loaded 153 scripts for scanning.<br />
            NSE: Script Pre-scanning.<br />
            Initiating NSE at 02:17<br />
            Completed NSE at 02:17, 0.00s elapsed<br />
            Initiating Ping Scan at 02:17<br />
            Completed Ping Scan at 02:17, 0.48s elapsed (1 total hosts)<br />
            Initiating Parallel DNS resolution of 1 host. at 02:17<br />
            Completed Parallel DNS resolution of 1 host. at 02:17, 0.15s elapsed<br />
            Initiating SYN Stealth Scan at 02:17<br />
            Scanning 165.22.187.222 [1000 ports]<br />
            Discovered open port 22/tcp on 169.42.31.219<br />
            Discovered open port 80/tcp on 169.42.31.219<br />
            Discovered open port 3306/tcp on 169.42.31.219<br />
            <span class="font-bold">PORT STATE SERVICE VERSION</span><br />
            22/tcp open ssh OpenSSH 7.6p1 Ubuntu 4ubuntu0.3<br />
            25/tcp filtered smtp<br />
            80/tcp open http Node.js Express framework<br />
            135/tcp filtered msrpc<br />
            3306/tcp open mysql MySQL 5.5.5-10.3.25-MariaDB<br />
            139/tcp filtered netbios-ssn<br />
            445/tcp filtered microsoft-ds<br />
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-3/5 w-full">
        <div class="grid grid-cols-2 lg:grid-cols-3 md:grid-cols-2 gap-4">
          <div class="flex items-center justify-between switch-item" v-for="item in switch_values" :key="item.name">
            <h2 class="mr-2 font-bold">{{ item.name }}</h2>
            <vs-switch color="success" class="ml-2" v-model="item.value" />
          </div>
        </div>
        <vs-divider class="mt-6 mb-6" />
        <div class="selector-container">
          <h2 class="selector-header">Service Selector</h2>

          <div
            class="selector-item"
            v-for="item in switch_values"
            v-show="item.value === item.answer && item.sci === true"
            :key="item.name"
          >
            <h5 class="my-2">{{ item.name }}</h5>
            <v-select placeholder="Select a service from the dropdown" class="w-full" :options="service_options" v-model="item.select" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      //Sim Variables
      switch_values: [
        {
          name: 'Port 80',
          select: null,
          select_answer: 3,
          value: false,
          answer: true,
          sci: true,
        },
        {
          name: 'Port 22',
          select: null,
          select_answer: 4,
          value: false,
          answer: true,
          sci: true,
        },
        {
          name: 'Port 3306',
          select: null,
          select_answer: 6,
          value: false,
          answer: true,
          sci: true,
        },
        {
          name: 'Port 443',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 69',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 21',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 23',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 67',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 128',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 25',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 49',
          value: false,
          answer: false,
          sci: false,
        },
        {
          name: 'Port 500',
          value: false,
          answer: false,
          sci: false,
        },
      ],

      service_options: [
        { id: 1, label: 'ProFTPD 1.2.4' },
        { id: 2, label: 'nginx/1.16.1' },
        { id: 3, label: 'Node.js Express framework' },
        { id: 4, label: 'OpenSSH 7.6p1 Ubuntu 4ubuntu0.3' },
        { id: 5, label: 'Apache Traffic Server 7.1.6' },
        { id: 6, label: 'MySQL 5.5.5-10.3.25-MariaDB-0ubuntu0.20.04.1' },
      ],

      //Sim Requirements
      dataLocal: JSON.parse(JSON.stringify(this.data)),
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;
      let simulation_bad = false;

      this.switch_values.forEach((x) => {
        if (x.value === x.answer && x.sci === true) {
          totalScore++;
        }

        if (x.value !== x.answer && x.sci !== true) {
          simulation_bad = true;
        }

        if (x.sci === true && x.select) {
          if (x.select.id === x.select_answer) {
            totalScore++;
          }
        }
      });

      if (simulation_bad) {
        this.$emit('simulation_getting_there', 0, false);
        return this.$vs.dialog({
          color: 'danger',
          title: 'Invalid Ports Selected!',
          text: "You selected some of the ports that weren't supposed to be checked, try again.",
        });
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  mounted() {
    //Shuffle
    this.switch_values = shuffle(this.switch_values);
    this.service_options = shuffle(this.service_options);
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
.switch-item {
  background-color: #02050d;
  border: 1px solid #181d2a;
  padding: 0.6rem 1.2rem 0.6rem 1.4rem;
  border-radius: 0.6rem;
}

.selector-container {
  background-color: #02050d;
  border: 1px solid #181d2a;
  border-radius: 0.6rem;
}

.selector-header {
  background-color: #02050d;
  padding: 1rem 1.2rem 1rem 1.2rem;
  border-radius: 0.6rem;
}

.selector-item {
  border-top: 1px solid #181d2a;
  padding: 0.8rem 1.2rem 1.6rem 1.2rem;
}
</style>
